import { SearchTab } from "@/components/search/SearchTab";
import "./SearchTabs.scss";

interface ISearchTabs {
  onClick: (tab: searchTabsEnum) => void;
  activeTab: string;
}

export enum searchTabsEnum {
  NICHES = "niches",
  CREATORS = "creators",
  TAGS = "tags",
  ALL = "all",
}

export const SearchTabs = ({ onClick, activeTab }: ISearchTabs) => (
  <div className="searchTabs">
    {Object.values(searchTabsEnum).map((tab) =>
      <SearchTab
        key={tab}
        onClick={onClick}
        tabName={tab}
        isActive={activeTab === tab}
      />
    )}
  </div>
);
